import {Checkbox} from '@practicegenius/pg-ui/src/base/Material/components/Checkbox';
import Box from '@mui/material/Box';
import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import {Grow} from '@mui/material';
import {Field} from '../../../@practicegenius/react-final-form';

const VERIFICATION_RANGE_MS = [1500, 3000];

type Verification = 'unverified' | 'pending' | 'verified';

type Props = {
  verifyHumanFieldName: string;
  honeyPotFieldName: string;
};

export const VerifyHumanPanel = ({
  verifyHumanFieldName,
  honeyPotFieldName,
}: Props) => {
  const [verification, setVerification] =
    React.useState<Verification>('unverified');

  // TODO replace with real human verification (or just remove it in favor of MFA)
  const verifyHuman = () => {
    return new Promise(resolve => {
      const timeout =
        Math.floor(
          Math.random() *
            (VERIFICATION_RANGE_MS[1] - VERIFICATION_RANGE_MS[0] + 1),
        ) + VERIFICATION_RANGE_MS[0];
      setTimeout(() => {
        setVerification('verified');
        resolve(void 0);
      }, timeout);
    });
  };

  return (
    <Grow in>
      <Box
        sx={{
          mt: 4,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            width: '300px',
            px: 1,
            py: 2,
            border: '1px solid',
            borderRadius: '20px',
            borderColor: 'primary.light',
            display: 'flex',
          }}
        >
          <Field name={verifyHumanFieldName} type="checkbox">
            {({input}) => (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                {/* @ts-expect-error */}
                <Checkbox
                  {...input}
                  checked={verification !== 'unverified'}
                  disabled={verification !== 'unverified'}
                  sx={{
                    '& .label': {
                      fontWeight: 600,
                      color:
                        verification === 'verified'
                          ? theme => theme.palette.success.main
                          : undefined,
                    },
                    '& .input.Mui-disabled': {
                      color:
                        verification === 'verified'
                          ? theme => theme.palette.success.main
                          : undefined,
                    },
                  }}
                  onChange={e => {
                    if (e.target.checked) {
                      setVerification('pending');
                      verifyHuman().then(() => {
                        setVerification('verified');
                        // @ts-expect-error Despite the TS issue, this works
                        input.onChange(true);
                      });
                    }
                  }}
                  label="I am a Human"
                />
                {verification === 'pending' && (
                  <CircularProgress
                    size={20}
                    sx={{
                      ml: 1,
                    }}
                  />
                )}
              </Box>
            )}
          </Field>
          <Box
            sx={{
              position: 'absolute',
              top: '-9999px',
            }}
          >
            <Field name={honeyPotFieldName} type="checkbox">
              {({input}) => (
                // @ts-expect-error
                <Checkbox
                  {...input}
                  tabIndex={-1}
                  checked={input.checked}
                  label="I am not a human"
                />
              )}
            </Field>
          </Box>
        </Box>
      </Box>
    </Grow>
  );
};
